import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import Report from '../../../common/components/Report';
import {
  getDefaultViewColumns,
  getAllLegViewColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/CarditResditEventOverviewSelectors';
import CarditResditEventOverviewReportMode from '../component/CarditResditEventOverviewReportMode';

const MODE_TABS = [
  { value: CarditResditEventOverviewReportMode.default, label: 'Default legs' },
  { value: CarditResditEventOverviewReportMode.allLeg, label: 'All legs' },
];

export class CarditResditEventOverviewContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reportMode: CarditResditEventOverviewReportMode.default,
    };
  }

  changeMode = reportMode => this.setState({ reportMode });

  renderDefault() {
    return (
      <Report
        reportId={ReportDefinitions.CARDIT_RESDIT_EVENT_OVERVIEW_105.id}
        generatedOnDateTime={this.props.generatedDateTime}
        isLoading={this.props.isLoading}
        data={this.props.data}
        columns={this.props.defaultViewColumns}
        modeTabs={MODE_TABS}
        changeMode={this.changeMode}
        mode={CarditResditEventOverviewReportMode.default}
      />
    );
  }

  renderAllLegs() {
    return (
      <Report
        reportId={ReportDefinitions.CARDIT_RESDIT_EVENT_OVERVIEW_105.id}
        generatedOnDateTime={this.props.generatedDateTime}
        isLoading={this.props.isLoading}
        data={this.props.data}
        columns={this.props.allLegViewColumns}
        modeTabs={MODE_TABS}
        changeMode={this.changeMode}
        mode={CarditResditEventOverviewReportMode.allLeg}
      />
    );
  }

  render() {
    switch (this.state.reportMode) {
      case CarditResditEventOverviewReportMode.default:
        return this.renderDefault();
      case CarditResditEventOverviewReportMode.allLeg:
        return this.renderAllLegs();
      default:
        return (<div id="report-mode-error">Report mode &quot;{this.state.reportMode}&quot; is not implemented</div>);
    }
  }
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    defaultViewColumns: getDefaultViewColumns(state),
    allLegViewColumns: getAllLegViewColumns(state),
  };
}

CarditResditEventOverviewContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  defaultViewColumns: PropTypes.arrayOf(PropTypes.object),
  allLegViewColumns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(CarditResditEventOverviewContainer);
